import { render, staticRenderFns } from "./BlockTxRow.vue?vue&type=template&id=187a3380&functional=true&"
import script from "./BlockTxRow.vue?vue&type=script&lang=js&"
export * from "./BlockTxRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports